A page of webhook attempts for the current event matching the specified criteria.

A maximum of 100 webhook attempts can be returned in a single page.
Additional webhook attempts can be queried using a pagination cursor.

The result list is returned in ascending creation date & time order.
It starts from the earliest known attempt if no pagination arguments are provided.
